import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import initialState from './initialState';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);
const state = Object.assign({}, initialState);

export const PERSIST_KEY = 'oisajf832nlaf0yhk3';

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  plugins: [
    createPersistedState({
      key: PERSIST_KEY,
      paths: ['signupToken', 'auth', 'campaignCode'], // sessionStorageに固定する特定のstate
      storage: window.sessionStorage
    })
  ],
  strict: process.env.NODE_ENV !== 'production'
});
